import React from "react";

import {
    ImportFormProps,
    IntegrationCategory,
    JudgmentIntegration,
    JudgmentIntegrationImportCommand,
    SaveJudgmentIntegrationCommand,
    DeleteJudgmentIntegrationCommand,
} from "../types/JudgmentIntegrationTypes";
import * as yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import judgmentStore from "../stores/judgment-store";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import JudgmentClient from "../Api/judgment-client";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

export const EditForm: React.FC<ImportFormProps> = function (props) {


    const nameHeaderFile = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Judgment Integration Name:" : "Satisfaction Integration Name";
    const judgmentfileType = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Civil Entries File" : "Civil Satisfaction File";


    const headerTemplate = () => {
        const headerText = judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment ? "Edit Imported Judgment Details" : "Edit Imported Satisfaction Details";
        const accept = () => {
            onDelete();
        }
        const confirmDelete = (event: { currentTarget: any; }) => {
            confirmPopup({
                target: event.currentTarget,
                message: 'Are you sure you want to delete this record?',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                accept
            })
        }
        async function onDelete() {
            const judgmentIntegrationId: number = judgmentStore.currentIntegration.id;
            const judgmentIntegrationCommand: DeleteJudgmentIntegrationCommand = { judgmentIntegrationId };
            JudgmentClient.deleteJudgmentIntegration(judgmentIntegrationCommand);
            let response = await JudgmentClient.getAllJudgementIntegrations();
            judgmentStore.judgmentIntegrations = response.judgmentIntegrations;
            judgmentStore.setInitialView();
            props.showToast("success", "Judgment successfully deleted", undefined, 5000);
        }
        function showDeleteButton() {
            if (judgmentStore.currentIntegration.statusID == 1 && judgmentStore.currentIntegration.canDeleteJudgmentIntegration == true) {
                return 'block';
            }
            else {
                return 'none'
            }
        }
        return (
            <>
                <div className="header">
                    <div className="title">{headerText}</div>

                    <Button
                        label="Delete"
                        type="button"
                        className="p-button-sm"
                        style={{
                            "width": "90px", "backgroundColor": "#dc3545", "borderColor": "#dc3545",
                            display: showDeleteButton()
                        }}
                        onClick={confirmDelete}
                    />

                    <Button
                        label="Save"
                        className="p-button-sm"
                        style={{ "width": "90px" }}
                    />
                </div>
            </>
        );
    }
    const formikProps = useFormik<JudgmentIntegrationImportCommand>({
        initialValues: {
            judgmentIntegrationName: judgmentStore.currentIntegration
                ? judgmentStore.currentIntegration.name
                : "",
            integrationCategoryID:
                judgmentStore.currentIntegration?.integrationCategoryID,
        },
        validationSchema: yup.object().shape({
            judgmentIntegrationName: yup
                .string()
                .required("Integration name is required.")
        }),
        onSubmit: async (
            values: JudgmentIntegrationImportCommand,
            { setSubmitting }: FormikHelpers<JudgmentIntegrationImportCommand>
        ) => {
            const judgmentIntegration: JudgmentIntegration = judgmentStore.currentIntegration!;
            judgmentIntegration.name = values.judgmentIntegrationName;

            const command: SaveJudgmentIntegrationCommand = { judgmentIntegration };

            let response = await JudgmentClient.saveJudgmentIntegration(command);
            if (response.errors && response.errors.length > 0) {
                props.showToast(
                    "error",
                    response.message ?? "",
                    response.errors[0],
                    undefined,
                    true
                );
            } else {
                props.showToast("success", response.message ?? "", undefined, 5000);
                judgmentStore.currentIntegration = response.judgmentIntegration;
            }


            setSubmitting(false);
        },

        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true,
    });

    const FileTemplate = (props: { fileTypeName: string, fileName: string, show: boolean }) => {
        if (props.show)
            return (
                <div className="p-field p-grid">
                    <div className="p-col-3 p-md-3">
                        <label>{props.fileTypeName}:</label>
                        &nbsp;&nbsp;
                    </div>
                    <div className="p-col-9 p-md-9">
                        {props.fileName}
                    </div>
                </div>

            )
        else
            return null;
    };
    return (
        <form onSubmit={formikProps.handleSubmit}>
            <Panel header={headerTemplate}>

                <div className="p-fluid">
                    <div className="p-field p-grid">
                        <label htmlFor="judgmentIntegrationName" className="p-col-3 p-md-3 " >
                            {nameHeaderFile}
                        </label>
                        <div className="p-col-9 p-md-9">
                            <InputText
                                name="judgmentIntegrationName"
                                className={
                                    formikProps.errors.judgmentIntegrationName &&
                                        formikProps.touched.judgmentIntegrationName
                                        ? "p-invalid"
                                        : ""
                                }
                                value={formikProps.values.judgmentIntegrationName}
                                onChange={formikProps.handleChange}
                            />
                            {formikProps.errors.judgmentIntegrationName &&
                                formikProps.touched.judgmentIntegrationName && (
                                    <Message
                                        severity="error"
                                        text={formikProps.errors.judgmentIntegrationName}
                                    ></Message>
                                )}
                        </div>
                    </div>

                    <FileTemplate
                        fileTypeName={judgmentfileType}
                        fileName={judgmentStore.currentIntegration?.civilEntriesFileName}
                        show={true}
                    ></FileTemplate>
                    <FileTemplate
                        fileTypeName="Alias File"
                        fileName={judgmentStore.currentIntegration?.aliasFileName}
                        show={judgmentStore.currentIntegration?.integrationCategoryID === IntegrationCategory.Judgment}
                    ></FileTemplate>

                </div>

            </Panel>
        </form>
    );
};
